export default "__VITE_ASSET__152c982b__"